<script>
import { benefits } from "@/views/home/utils/benefits.js";

export default {
  name: "home-benefits",
  data() {
    return {
      benefits: benefits,
    };
  },
  methods: {
    viewMore() {
      window.open(
        "https://www.grupodpsp.com.br/quem-somos/#diversidade",
        "_blank"
      );
    },
  },
};
</script>

<template>
  <div id="selective-process" class="selective-process">
    <div class="container">
      <section>
        <router-link :to="{ name: 'eligibility.rules' }"
          >Clique aqui e veja as Regras de Elegibilidade</router-link
        >
        <header>
          <h2>Confira o passo a passo do nosso processo seletivo:</h2>

          <h3>
            Fique por dentro: esse é o passo a passo do  nosso processo geral, as etapas e quantidade de dias podem ter alterações de acordo com cada oportunidade/posição.
          </h3>
        </header>
      </section>
      <section class="selective-process__flow">
        <div class="line"></div>
        <div class="selective-process__flow__start">
          <span> Início </span>
        </div>
        <ul class="selective-process__flow__column">
          <li class="selective-process__flow__row">
            <div style="background-color: #99e1ff">
              <span class="dark"> 6 dias </span>
              <h3 class="dark">Inscrição</h3>
              <p class="dark">
                Escolha a vaga e faça a sua inscrição nessa página!
              </p>
            </div>
          </li>
          <li class="selective-process__flow__row">
            <div style="background-color: #2e3447">
              <span> 6 dias </span>
              <h3>Triagem</h3>
              <p>Nessa etapa avaliamos se o seu perfil é elegível à vaga.</p>
            </div>
          </li>
          <li class="selective-process__flow__row">
            <div style="background-color: #ff5d5c">
              <span> 5 dias </span>
              <h3>Testes</h3>
              <p>
                Você poderá fazer alguns testes como Assessment, Excel, entre
                outros.
              </p>
            </div>
          </li>
          <li class="selective-process__flow__row">
            <div style="background-color: #3d83f5">
              <span> 3 dias </span>
              <h3>Atração e Seleção</h3>
              <p>
                Aqui podem acontecer entrevistas ou dinâmicas em grupo com o
                nosso time de Atração.
              </p>
            </div>
          </li>
          <li class="selective-process__flow__row">
            <div style="background-color: #f7dd6a">
              <span> 3 dias </span>
              <h3>Entrevista com a gestão</h3>
              <p>
                Aqui você vai bater um papo com a gestão da vaga e se necessário
                com outras pessoas da área.
              </p>
            </div>
          </li>
          <li class="selective-process__flow__row">
            <div style="background-color: #ffa1e2; border-radius: 200px">
              <h3 class="dark">Aprovação!</h3>
              <p class="dark">
                Parabéns! Chegar até aqui significa que você teve sucesso no
                processo. A partir de agora, o fluxo seguirá de acordo com as
                regras que comentamos lá em cima :)
              </p>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/selectiveProcess.scss"></style>